import React from 'react';
import { useTranslation } from '../../hx/useTranslation';
import CxSearcher from '../../cx/CxSearcher';
import CxSnackbar from '../../cx/CxSnackbar';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import '../../../styles/main.css';
import GxForm from '../../gx/GxForm';
import CxIconButton from '../../cx/CxIconButton';
//import { useNav } from '../../hx/useNav';


const MxSettAnimalMergeForm = (props) => {
  const [{ trans }] = useTranslation();
  //const [{ navBack }] = useNav();
  const r_snack_required = React.useRef(null);
  const r_snack_same_item = React.useRef(null);
  const r_snack_op_in_progress = React.useRef(null);
  const r_snack_op_successful = React.useRef(null);
  let r_form = React.useRef(null);

  const rf_txAnimalToKeep = React.useRef(null);
  const rf_txAnimalToDelete = React.useRef(null);


  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);
  
  const doMerge = () => {
    // chequea requeridos
    if (rf_txAnimalToKeep.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txAnimalToKeep.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txAnimalToDelete.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txAnimalToDelete.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txAnimalToKeep.current.getKey()===rf_txAnimalToDelete.current.getKey()) {
      r_snack_same_item.current.setOpen(true);
      return;
    }
    
    let inAnimal_toKeep = rf_txAnimalToKeep.current.getKey();
    let inAnimal_toDelete = rf_txAnimalToDelete.current.getKey();

    let record = {};
    record['inAnimal_toKeep'] = inAnimal_toKeep;
    record['inAnimal_toDelete'] = inAnimal_toDelete;
    r_snack_op_in_progress.current.setOpen(true);
    Promise.all([FxFetch.doJsonX(`sett/animal/merge/do`, record)]).then((result) => {
      rf_txAnimalToKeep.current.clear();
      rf_txAnimalToDelete.current.clear();
      r_snack_op_in_progress.current.setOpen(false);
      r_snack_op_successful.current.setOpen(true);
    });
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.merge_x', 'field.patients')}`}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButton type="issue" classType="ibs_iconbutton_toolbar" onClick={doMerge} tooltip={trans('field.merge_duplicates')} />
          </div>
        }
      >

      <CxSearcher xref={rf_txAnimalToKeep}
        label={trans('field.keep')}
        url="animals" 
        col_id="inAnimal" 
        col_tx="txAnimal"
        tooltip={`${trans('field.client')} / ${trans('field.patient')}`}
        columns={[
          { id: "0", Header: "ID", accessor: "inAnimal", show: false },
          { id: "1", Header: trans('field.patient'), accessor: row => rf_txAnimalToKeep.current.getTable().highlightText(row["txAnimal"]), width: '30%' },
          { id: "2", Header: trans('field.client'), accessor: row => rf_txAnimalToKeep.current.getTable().highlightText(row["txClient"]), width: '70%' },
        ]}
        width='var(--ibs_control_width_md)'
        required
      />

      <CxSearcher xref={rf_txAnimalToDelete}
        label={trans('field.delete')}
        url="animals" 
        col_id="inAnimal" 
        col_tx="txAnimal"
        tooltip={`${trans('field.client')} / ${trans('field.patient')}`}
        columns={[
          { id: "0", Header: "ID", accessor: "inAnimal", show: false },
          { id: "1", Header: trans('field.patient'), accessor: row => rf_txAnimalToDelete.current.getTable().highlightText(row["txAnimal"]), width: '30%' },
          { id: "2", Header: trans('field.client'), accessor: row => rf_txAnimalToDelete.current.getTable().highlightText(row["txClient"]), width: '70%' },
        ]}
        width='var(--ibs_control_width_md)'
        required
      />

      </GxForm>

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_same_item} severity="error" value={trans('msg.same_item')} />
      <CxSnackbar xref={r_snack_op_in_progress} severity="info" value={trans('msg.operation_in_progress')} autoHideDuration={10000} />
      <CxSnackbar xref={r_snack_op_successful} severity="success" value={trans('msg.operation_successful')} />
    </div>
  );

}

export default MxSettAnimalMergeForm;
